var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.72 759.51c11.311 0 20.48-9.17 20.48-20.481v-582.058c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v582.058c0 11.311 9.169 20.481 20.48 20.481zM214.643 753.201c6.076 2.784 13.513 2.651 19.436-0.346l576-291.447c5.669-2.867 9.122-7.942 9.122-13.408s-3.453-10.541-9.122-13.408l-576-291.447c-5.923-2.998-13.359-3.129-19.436-0.346-6.076 2.781-9.843 8.045-9.843 13.754v582.894c0 5.71 3.766 10.973 9.843 13.754z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.bca04e9d1fa494a38737457a1763216f.svg";
export { ForwardRef as ReactComponent };